/* @ngInject */

export default (ReviewProductSplit, dateTimeService) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function SwitchReviewProduct(id, productSplits, switchTimeStamp, isActive) {
    this.id = id;
    this.productSplits = productSplits;
    this.switchTimeStamp = switchTimeStamp;
    this.isActive = isActive;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  SwitchReviewProduct.Blank = function () {
    return SwitchReviewProduct.Build({
      id: _.uuid(),
      productSplits: [],
      switchTimeStamp: dateTimeService.epoch(),
      isActive: true
    });
  };
  SwitchReviewProduct.Build = function (data) {
    return new SwitchReviewProduct(
      data?.id || _.uuid(),
      _.map(_.compact(data?.productSplits), (productSplit) =>
        ReviewProductSplit.Build(productSplit)
      ),
      data?.switchTimeStamp ? parseInt(data.switchTimeStamp || 0, 10) : dateTimeService.epoch(),
      data?.isActive === true
    );
  };

  return SwitchReviewProduct;
};
